var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIngredient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 11.0263C14.1673 11.0263 13.4097 10.6417 12.6522 10.6417C11.5158 10.6417 10.0007 12.1802 10.0007 14.4878C10.0007 16.7954 12.0753 18.334 14.1673 18.334C16.2593 18.334 18.334 16.7954 18.334 14.4878C18.334 12.1802 16.8188 10.6417 15.6825 10.6417C14.9249 10.6417 14.1673 11.0263 14.1673 11.0263ZM14.1673 11.0263C14.1673 9.87247 14.9249 8.33398 16.44 8.33398",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.87913 4.16602C9.62601 4.16602 10.2315 3.60637 10.2315 2.91602C10.2315 2.22566 9.62601 1.66602 8.87913 1.66602L4.37134 1.66602C3.62447 1.66602 3.019 2.22566 3.019 2.91602C3.019 3.60637 3.62447 4.16602 4.37134 4.16602M9.30772 4.10194C10.1039 5.57387 10.7579 6.90216 11.1574 8.33268C11.19 8.44942 11.2209 8.56683 11.25 8.68507M8.69001 18.3327H5.2729C2.28934 18.3327 1.66667 17.7571 1.66667 14.9993L1.66667 11.4803C1.66667 8.64714 2.58131 6.5707 3.92056 4.09489",
    stroke: "#242428",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIngredient);
export default __webpack_public_path__ + "static/media/icon-ingredient.60e893ea6a4282e7d1b6c88d282b54cf.svg";
export { ForwardRef as ReactComponent };